import { useCallback } from 'react';
import cl from 'classnames';

import { ClassName } from '../../../../types';
import { IconsEnum } from '../../../../assets/icons/types';

import {
  StarsRadioButtonsValue,
  StarsRadioButtonsOnChange
} from '../../StarsRadioButtons.types';

import { Icon } from '../../../Icon';

export interface StarsRadioButtonsItemProps {
  name: string;
  value?: StarsRadioButtonsValue;
  buttonValue: StarsRadioButtonsValue;
  disabled?: boolean;
  iconClassName?: ClassName;
  onChange: StarsRadioButtonsOnChange;
  id?: string;
}

function StarsRadioButtonsItem({
  name,
  value,
  buttonValue,
  disabled,
  iconClassName,
  onChange,
  id = 'star-radio-button'
}: StarsRadioButtonsItemProps) {
  const handleChange = useCallback<() => void>(() => {
    onChange(buttonValue);
  }, [buttonValue, onChange]);

  const inputId = `${id}-${name}-${buttonValue}`;

  return (
    <>
      <input
        id={inputId}
        type="radio"
        name={name}
        value={buttonValue}
        checked={value === buttonValue}
        className="sr-only"
        disabled={disabled}
        onChange={handleChange}
      />
      <label htmlFor={inputId} className={cl({ hidden: buttonValue === 0 })}>
        <Icon
          icon={IconsEnum.FILLED_STAR}
          className={iconClassName || 'h-6 w-6'}
        />
      </label>
    </>
  );
}

export default StarsRadioButtonsItem;
